import { motion } from "framer-motion";
import { Zap, Layers, Shield } from "lucide-react";

const items = [
  {
    icon: Zap,
    title: "Speed to Market",
    desc: "Our AI-first internal frameworks drastically reduce the time from concept to deployment—shipping in weeks, not quarters.",
  },
  {
    icon: Layers,
    title: "Cost-Effective Architecture",
    desc: "Engineered to minimize infrastructure overhead, passing the savings directly to you through predictable, transparent pricing.",
  },
  {
    icon: Shield,
    title: "Uncompromising Security",
    desc: "Built on modern security standards to ensure your corporate data remains completely isolated and safe at every layer.",
  },
];

export const WhyPartner = () => {
  return (
    <section
      id="partner"
      className="relative py-24 sm:py-32 border-t border-white/5"
      data-testid="partner-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#06B6D4]">
            Why Partner With Us
          </span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white">
            Built for the way modern enterprises move
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="group relative bg-[#0F172A]/50 border border-white/5 rounded-2xl p-8 hover:border-[#6366F1]/40 transition-all duration-300 overflow-hidden"
              data-testid={`partner-card-${i}`}
            >
              <div className="absolute -top-px left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#6366F1]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-[#6366F1]/20 to-[#06B6D4]/20 border border-white/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <it.icon className="text-[#06B6D4]" size={26} />
              </div>
              <h3 className="font-heading text-xl font-semibold text-white">
                {it.title}
              </h3>
              <p className="mt-3 text-[#94A3B8] leading-relaxed">{it.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
